import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_kiosque-eau/artifacts/4sxb5co7_logo%20kiosques%20%C3%A0%20eau%20rond_png.avif';

const TOKEN_KEY = 'kae_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// Public endpoints
export const createContact = (data) => api.post('/contact', data).then((r) => r.data);
export const createDonation = (data) => api.post('/donations', data).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post('/newsletter', { email }).then((r) => r.data);
export const fetchArticles = (params = {}) => api.get('/articles', { params }).then((r) => r.data);
export const fetchArticle = (slug) => api.get(`/articles/${slug}`).then((r) => r.data);

// Admin endpoints
export const adminLogin = (password) => api.post('/admin/login', { password }).then((r) => r.data);
export const adminCheck = () => api.get('/admin/me').then((r) => r.data);
export const adminStats = () => api.get('/admin/stats').then((r) => r.data);
export const adminListContacts = () => api.get('/admin/contacts').then((r) => r.data);
export const adminMarkContact = (id, read) => api.patch(`/admin/contacts/${id}`, { read }).then((r) => r.data);
export const adminDeleteContact = (id) => api.delete(`/admin/contacts/${id}`).then((r) => r.data);
export const adminListDonations = () => api.get('/admin/donations').then((r) => r.data);
export const adminDeleteDonation = (id) => api.delete(`/admin/donations/${id}`).then((r) => r.data);
export const adminListArticles = () => api.get('/admin/articles').then((r) => r.data);
export const adminGetArticle = (id) => api.get(`/admin/articles/${id}`).then((r) => r.data);
export const adminCreateArticle = (data) => api.post('/admin/articles', data).then((r) => r.data);
export const adminUpdateArticle = (id, data) => api.put(`/admin/articles/${id}`, data).then((r) => r.data);
export const adminDeleteArticle = (id) => api.delete(`/admin/articles/${id}`).then((r) => r.data);

// Site content (CMS)
export const fetchContent = () => api.get('/content').then((r) => r.data);
export const adminGetContent = (section) => api.get(`/admin/content/${section}`).then((r) => r.data);
export const adminUpdateContent = (section, data) => api.put(`/admin/content/${section}`, { data }).then((r) => r.data);
export const adminResetContent = (section) => api.post(`/admin/content/${section}/reset`).then((r) => r.data);
